import * as React from 'react';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { getUnits } from '../utility/units';
import { useGridApiContext } from '@mui/x-data-grid';


export default function UnitSelect(props) {


  const [open, setOpen] = React.useState(true);
  const closePopper = () => setOpen(false);
  const openPopper = () => setOpen(true);
 
  const apiRef = useGridApiContext();
  const onChangeHandler =(ev,value)=>{
    ev.stopPropagation();

    var field = props.field;
    var id = props.id;     

    apiRef.current.setEditCellValue({
        id,
        field,    
        value: value,
      });
    apiRef.current.stopCellEditMode({ id, field, ignoreModifications: false });
    closePopper();
  }

  const onTextInputFocus= (ev)=>{   
      ev.target.select();
    }
  

  return (
    <Autocomplete    
      freeSolo
      value={props.value}
      open={open}      
      autoFocus
      onFocus={openPopper} 
      onClose={closePopper}
      onChange={onChangeHandler}
      options={getUnits()} 
      renderInput={(params) => (
        <TextField               
          autoFocus            
          onFocus={onTextInputFocus}   
          {...params}       
             
        />)}
    />
  );
}